import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import ResultadoMotorCreditoList from './OpcaoConsultaLoteList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import ResultadoMotorCreditoCadastrar from './OpcaoConsultaLoteCadastrar';
import { Messages } from 'primereact/messages';
import postOpcaoConsultaLote from '../../service/postOpcaoConsultaLote';
import putOpcaoConsultaLote from '../../service/putOpcaoConsultaLote';

export default function OpcaoConsultaLotePage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [opcaoConsulaLote, setOpcaoConsultaLote] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveOpcaoConsultaLote = (opcaoConsulaLote:any) => {
    if(opcaoConsulaLote.id){
      putOpcaoConsultaLote(opcaoConsulaLote).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setOpcaoConsultaLote(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postOpcaoConsultaLote(opcaoConsulaLote).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setOpcaoConsultaLote(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setOpcaoConsultaLote({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-database" style={{ fontSize: '2.0rem' }}></i> {t('opcaoConsultaLote')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!opcaoConsulaLote && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <ResultadoMotorCreditoList onEdit={(opcaoConsulaLote:any) => { setOpcaoConsultaLote(opcaoConsulaLote);}}></ResultadoMotorCreditoList>
          </>
        )}
        {opcaoConsulaLote && (
          <>
           <ResultadoMotorCreditoCadastrar opcaoConsulaLote={opcaoConsulaLote} onSave={saveOpcaoConsultaLote} onClose={() => {setOpcaoConsultaLote(null)}}></ResultadoMotorCreditoCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
